// TODO: remove the tutorial page
export function linkToTutorialPage() {
  return "/tutorial";
}
